<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="tree-section-container" :class="{ empty: menuTree.length === 0 }">
				<div>
					<el-tree :data="menuTree" @node-click="handleNodeClick"></el-tree>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupControlManagement/store/helpers';
import utils from '@/utils';
export default {
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...utils,
		...rootMethods,
		...serviceMethods,
		setTreeList() {
			this.handleNodeClick();
			this.$sf_toggleLoading(true);
			this.getScreens_({ plantCd: this.user.plantCd, langCd: this.user.langCd })
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message ? error.message : error
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		handleNodeClick(row) {
			if (!this.isNull(row) && !this.isUndefined(row)) {
				this.setSearchParam_({ key: 'screenId', value: row.scrId });
				this.setSearchParam_({ key: 'scrUrl', value: row.scrUrl });
				this.$emit('SelectUserGroupScreenFunction', row.scrName);
			}
		}
	}
};
</script>

<style>
.tree-section-container {
	height: 100%;
	display: flex;
	flex-direction: column;
	background-color: #ffffff;
	overflow-y: scroll;

	border-right: none;
	border-bottom: none;
	border-radius: 5px;
	border: 1px solid #8da1b9;
}
</style>
